module.exports = "/packs/spinner-a800e74ac892208654d739f48d420489.svg";